package ru.malygin.urls.url

class GetDataForFindTeacher {
    val urlHead = "/getDataForFindTeacher"
}